import axios from "axios";

export const getAllCoupons = async () => await axios.get("/coupon/");
export const getCouponWithCouponId = async (couponId: string) =>
  await axios.get(`/coupon/couponId/${couponId}`);

export const useCoupon = async (uid: string, codeCoupon: string) =>
  await axios.post("/coupon/useCoupon", { uid, codeCoupon });

export const generateCoupon = async (
  couponId: string,
  expiresDate: string | Date | number
) =>
  await axios.post("/coupon/genCode", {
    expiresDate: new Date(expiresDate).toISOString(),
    couponId,
  });

export const createCoupon = async (data: any) =>{
  await axios.post("/coupon/", data);}

export const deleteCoupon = async (couponId: string) =>
  await axios.delete("/coupon/" + couponId);
